import { render, staticRenderFns } from "./InformeFlow.vue?vue&type=template&id=9992bce8&scoped=true&"
import script from "./InformeFlow.vue?vue&type=script&lang=js&"
export * from "./InformeFlow.vue?vue&type=script&lang=js&"
import style0 from "./InformeFlow.vue?vue&type=style&index=0&id=9992bce8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9992bce8",
  null
  
)

export default component.exports